import React from 'react';

const DocumentViewModal = ({ document, onClose }) => {
    if (!document) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={e => e.stopPropagation()} style={{ width: '800px', maxWidth: '90vw' }}>
                <div className="modal__header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <h2 style={{ margin: 0 }}>{document.filename}</h2>
                    <button className="btn btn--sm" onClick={onClose}>Close</button>
                </div>
                <div className="modal__content">
                    <div className="document-content-view" style={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        padding: '1rem',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        whiteSpace: 'pre-wrap',
                        fontFamily: 'monospace'
                    }}>
                        {document.content_text || "No content available to preview."}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentViewModal;
